import {Controller} from "stimulus"

// The codes case index filter bar. Every change rebuilds the index URL from
// all of the controls and navigates to it; Codes::CaseSearch reads it back.
export default class extends Controller {
    static targets = ["active", "unassigned", "assignees", "statuses", "priorities", "remediationStart", "remediationEnd"];

    // Parcels rendered by the server as already selected arrive as plain
    // search results. Tag them the way the picker tags a fresh selection, or
    // the next filter change would silently drop them.
    connect() {
        this.selectedParcelsArea().querySelectorAll('.result-location').forEach(parcel => {
            parcel.classList.add('result-parcel');
            parcel.querySelectorAll('.delete-action').forEach(action => action.classList.remove('hidden'));
        });
    }

    disconnect() {
        clearTimeout(this.delayTimer);
    }

    getReport() {
        this.reloadReport({keepStatuses: true});
    }

    // Multi-selects fire on every pick, so wait for the user to finish.
    getDelayedReport() {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.getReport(), 1500);
    }

    // The status select's default follows the Active checkbox (the open
    // statuses when on, every status when off), so toggling Active lets the
    // server pick the matching default rather than keeping the old one.
    toggleActive() {
        this.reloadReport({keepStatuses: false});
    }

    removeParcel(e) {
        e.preventDefault();
        e.target.closest('.result-parcel').remove();
        this.getReport();
    }

    reloadReport({keepStatuses}) {
        const query = new URLSearchParams({
            active: this.activeTarget.checked,
            unassigned: this.unassignedTarget.checked,
            assignees: this.selectedValues(this.assigneesTarget),
            priorities: this.selectedValues(this.prioritiesTarget),
            remediation_start: this.remediationStartTarget.value,
            remediation_end: this.remediationEndTarget.value,
            parcels: this.selectedParcelIds()
        });
        if (keepStatuses) query.set('statuses', this.selectedValues(this.statusesTarget));
        // The case type has no control on the bar; carry the one the page
        // was opened with so a filter change does not widen the list.
        const caseTypeId = this.data.get('caseTypeId');
        if (caseTypeId) query.set('codes_case_type_id', caseTypeId);
        this.navigateTo("/codes/cases?" + query.toString());
    }

    selectedValues(select) {
        return Array.from(select.selectedOptions).map(option => option.value).join(',');
    }

    selectedParcelIds() {
        return Array.from(this.selectedParcelsArea().querySelectorAll('.result-parcel'))
            .map(parcel => parcel.id).join(',');
    }

    selectedParcelsArea() {
        return this.element.querySelector('.selected-parcels');
    }

    // The single seam that leaves the page; jsdom does not implement
    // navigation, so the tests spy on this.
    navigateTo(url) {
        window.location.href = url;
    }
}
